import { FrameSourceState } from '@scandit/web-datacapture-core'
import type { DataCaptureView } from '@scandit/web-datacapture-core'
import {
  type LabelCapture,
  LabelCaptureAdaptiveRecognitionOverlay,
  LabelCaptureFeedback,
  LabelCaptureSettings,
  ReceiptScanningResult,
} from '@scandit/web-datacapture-label'
import type { LabelPreset } from '../LabelCaptureSettingsStore'
import type { ControllerDeps, PresetController, Teardown } from './PresetController'

export class ShoppingReceiptController implements PresetController {
  readonly preset: LabelPreset = 'shoppingReceipt'

  constructor(private readonly deps: ControllerDeps) {}

  async pause(mode: LabelCapture): Promise<void> {
    await mode.setEnabled(false)
    await mode.context?.frameSource?.switchToDesiredState(FrameSourceState.Standby)
  }

  async resume(mode: LabelCapture): Promise<void> {
    await mode.setEnabled(true)
    await mode.context?.frameSource?.switchToDesiredState(FrameSourceState.On)
  }

  async buildSettings(): Promise<LabelCaptureSettings> {
    return LabelCaptureSettings.fromLabelDefinitions([])
  }

  async activate(mode: LabelCapture, view: DataCaptureView): Promise<Teardown> {
    mode.feedback = LabelCaptureFeedback.default

    const overlay = await LabelCaptureAdaptiveRecognitionOverlay.withLabelCaptureForView(mode, view)
    overlay.listener = {
      onRecognized: (result) => {
        if (result instanceof ReceiptScanningResult) {
          this.deps.listStore.addFromReceiptScanningResult(result)
        }
      },
      onFailure: () => {},
    }

    await mode.setEnabled(true)
    await mode.context?.frameSource?.switchToDesiredState(FrameSourceState.On)

    return async () => {
      await view.removeOverlay(overlay)
    }
  }
}
